
import React, { Component } from 'react'
//样式
import {
    Container
} from "./style";

//redux
import { connect } from 'react-redux'
import { List,Space } from 'antd';
import {ImageViewer, Ellipsis, Divider, Grid, Image, Toast} from 'antd-mobile';
import {Badge } from 'antd-mobile-v2';
import {setVideoPlayData} from "../../components/VideoPlayer/store/actionCreators";
import {getHeaderData} from "../../common/Header/store/actionCreators";
import { MessageOutlined, LikeOutlined, StarOutlined } from '@ant-design/icons';
import $axios from "../../request";

const IconText = ({ icon, text }) => (
    <Space>
        {React.createElement(icon)}
        {text}
    </Space>
)

class CreationChartItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            listItem:props.item,
        }
    }
    componentDidMount() {


    }
    handleFun(to) {
        to+='?&time='+Date.parse(new Date())
        this.props.history.push(to)
    }


    render() {
        let {
            listItem
        } = this.state
        //console.log("listItem",listItem)
        return (
            <Container>



                    <List.Item
                        key={listItem.id}
                        style={{padding:'0'}}
                    >
                        <div className="baseDiv">

                            {
                                listItem.chartNum<=2&&<div className="chartNum" style={{backgroundImage: "url("+ require(`assets/images/num${listItem.chartNum+1}.png`)+")"}}>{listItem.chartNum+1}</div>
                            }
                            {
                                listItem.chartNum>2&&<div className="chartNum" >{listItem.chartNum+1}</div>
                            }

                            <div className="cDes">
                                <span className="creationDes">
                                     <Grid  columns={16} >
                                         <Grid.Item className='grid-item' span={4}><Badge text="标题" style={{ backgroundColor: '#36BEF1', borderRadius: 9 }} /></Grid.Item><Grid.Item span={12}><Ellipsis className='titleSmall' direction='end' content={listItem.title} rows={2} /></Grid.Item>
                                          <Grid.Item className='grid-item' span={4}><Badge text="作者" style={{ backgroundColor: '#36BEF1', borderRadius: 9 }} /></Grid.Item><Grid.Item span={12}><Ellipsis className='titleSmall' direction='end' content={listItem.userName} /></Grid.Item>
                                          <Grid.Item className='grid-item' span={4}><Badge text="单位" style={{ backgroundColor: '#36BEF1', borderRadius: 9 }}  /></Grid.Item><Grid.Item span={12}><Ellipsis className='titleSmall' direction='end' content={listItem.companyName} /></Grid.Item>
                                          <Grid.Item className='grid-item' span={4}><Badge text="板块" style={{ backgroundColor: '#36BEF1', borderRadius: 9 }} /></Grid.Item><Grid.Item span={12}><Ellipsis className='titleSmall' direction='end' content={listItem.tagname} /></Grid.Item>
                                     </Grid>
                                </span>
                            </div>
                            {
                                listItem.voteTypeEnum?.name === 'IMG'&&
                                <div className='imgBg'
                                     onClick={() => {
                                         //ImageViewer.Multi.show({images:listItem.imgPathShow.toImg()});
                                         this.handleFun('/creationDetail/'+listItem.id);
                                     }}>
                                    <Image src={listItem.imgPathShow[0].toImg()} style={{height:110}} alt="" />
                                    <div align="center" style={{height:20}}>
                                        <span style={{fontSize:"12px",textAlign:"center",color:"#8F999F"}}>编号：{listItem.creationNo+1}</span>
                                        <span style={{fontSize:"12px",textAlign:"center",color:"#8F999F"}}>  投票：{listItem.likeNum?listItem.likeNum:0}</span>
                                    </div>

                                </div>
                            }
                            {
                                listItem.voteTypeEnum?.name === 'VIDEO'&&
                                <div className='vodBg'
                                     style={{backgroundImage: "url(" + listItem.vodCover.toImg() + ")"}}
                                     onClick={() => {
                                         //this.handleFun('/aliplayer/'+listItem.vodId);
                                         this.handleFun('/creationDetail/'+listItem.id);
                                     }}>
                                    <div  className='imgCenter' style={{height:110,borderTopRightRadius:"20px"}}>
                                        <img
                                            src={require("assets/images/play.png")}
                                            width={64}
                                            height={64}
                                            fit='cover'
                                        />
                                    </div>
                                    <div align="center" style={{height:20}}>
                                        <span style={{fontSize:"12px",textAlign:"center",color:"#8F999F"}}>编号：{listItem.creationNo+1}</span>
                                        <span style={{fontSize:"12px",textAlign:"center",color:"#8F999F"}}>  投票：{listItem.likeNum||0}</span>
                                    </div>
                                </div>
                            }

                        </div>
                    </List.Item>


            </Container>

        )
    }
}

const mapState =state => {

    return {

    }
}
const mapDispatch =dispatch => {
    return {
        _setVideoPlayData(data) {
            dispatch(setVideoPlayData(data))
        },
        _getHeaderData(data) {
            dispatch(getHeaderData(data))
        },


    }
}

export default connect(mapState, mapDispatch)(CreationChartItem)
